import React, { useState } from "react";
import { makeStyles } from "tss-react/mui";
import { Dialog, DialogContent } from "@mui/material";
import { useResponsiveSize } from "../utils/useResponsiveSize";
import { primaryColor } from "../assets/colors";
import NavigationComponent from "./navigationComponent";
import BannerComponent from "./bannerComponent";
import ContentComponent from "./content/contentComponent";
import FooterComponent from "./footerComponent";
// import Contact from './contact/contact';

const useStyles = makeStyles<{ navHeight: number }>()((theme, params) => ({
  mainContainer: {
    backgroundColor: "black",
    paddingTop: params.navHeight,
  },
  dialogContent: {
    padding: "32px",
    fontFamily: "League Gothic",
    fontWeight: 600,
    letterSpacing: "1.2px",
    fontSize: "30px",
  },
  navItem: {
    display: "flex",
    justifyContent: "center",
    padding: "16px 0px",
  },
}));

const MainComponent: React.FC = () => {
  const navHeight = useResponsiveSize();
  const { classes } = useStyles({ navHeight });
  const [open, setOpen] = useState<boolean>(false);
  // const [contactOpen, setContactOpen] = useState<boolean>(false);

  const topRef: React.Ref<HTMLDivElement> = React.createRef<HTMLDivElement>();
  const newsRef: React.Ref<HTMLDivElement> = React.createRef<HTMLDivElement>();
  const showsRef: React.Ref<HTMLDivElement> = React.createRef<HTMLDivElement>();
  const bandRef: React.Ref<HTMLDivElement> = React.createRef<HTMLDivElement>();
  const contactRef: React.Ref<HTMLDivElement> =
    React.createRef<HTMLDivElement>();

  const onNavigate = (section: string) => {
    const getOffsetAndScroll = (el: HTMLDivElement | null) => {
      if (!el) return;
      const y = el.getBoundingClientRect().top + window.pageYOffset - navHeight; // -8 for a little spacing
      window.scrollTo({ top: y, behavior: "smooth" });
    };

    if (section === "news") getOffsetAndScroll(newsRef.current);
    else if (section === "shows") getOffsetAndScroll(showsRef.current);
    else if (section === "band") getOffsetAndScroll(bandRef.current);
    else if (section === "contact") getOffsetAndScroll(contactRef.current);
    else if (section === "top") getOffsetAndScroll(topRef.current);
  };

  const handleNavigate = (section: string) => {
    onNavigate && onNavigate(section);
    setOpen(false);
  };

  const handleOpenMenu = () => setOpen((prev) => !prev);

  // const handleContactOpen = (value: boolean) => setContactOpen(value);

  return (
    <>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullWidth
        maxWidth={false}
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start",
            paddingTop: "80px",
          },
          "& .MuiPaper-root": {
            borderRadius: 0,
            backgroundColor: "black",
            color: primaryColor,
            margin: "0px",
            width: "100%",
            maxWidth: "100%",
          },
        }}
      >
        <DialogContent className={classes.dialogContent}>
          <div
            className={classes.navItem}
            onClick={() => handleNavigate("news")}
          >
            UUTISET
          </div>
          <div
            className={classes.navItem}
            onClick={() => handleNavigate("shows")}
          >
            KEIKAT
          </div>
          <div
            className={classes.navItem}
            onClick={() => handleNavigate("band")}
          >
            BÄNDI
          </div>
          <div
            className={classes.navItem}
            onClick={() => handleNavigate("contact")}
          >
            YHTEYS
          </div>
        </DialogContent>
      </Dialog>
      <div className={classes.mainContainer}>
        {/* <Contact
          contactOpen={contactOpen}
          handleContactOpenCB={handleContactOpen}
        /> */}
        <NavigationComponent
          onNavigate={onNavigate}
          handleOpenMenu={handleOpenMenu}
        />
        <BannerComponent
          topRef={topRef}
          // handleContactOpenCB={handleContactOpen}
        />
        <ContentComponent
          newsRef={newsRef}
          showsRef={showsRef}
          bandRef={bandRef}
          contactRef={contactRef}
        />
        <FooterComponent />
      </div>
    </>
  );
};

export default MainComponent;
